export * from '../shared/constants';

export const ONBOARDING_BASE_PATH = '/create-stack';
